import src0 from '../assets/img/hub-clubs/AVL-Himachal_Avalanche.webp';
import src1 from '../assets/img/hub-clubs/BBZ-BBZ_FC.webp';
import src2 from '../assets/img/hub-clubs/BDB-Blue_Devils_Busan.webp';
import src3 from '../assets/img/hub-clubs/CCC-Cusco_Conductores.webp';
import src4 from '../assets/img/hub-clubs/COB-Cobras_United.webp';
import src5 from '../assets/img/hub-clubs/COP-Copthorne_SA.webp';
import src6 from '../assets/img/hub-clubs/FLC_Doha_Falcons.webp';
import src7 from '../assets/img/hub-clubs/GAU-Cordoba_Gauchos.webp';
import src8 from '../assets/img/hub-clubs/GIZ_Giza_Club.webp';
import src9 from '../assets/img/hub-clubs/GRR-Sarabi_SC.webp';
import src10 from '../assets/img/hub-clubs/GYM-The_Gymnastic_Society.webp';
import src11 from '../assets/img/hub-clubs/HOS-Barts_Hospital.webp';
import src12 from '../assets/img/hub-clubs/IDF-Ile-de-France_Foot.webp';
import src13 from '../assets/img/hub-clubs/INT-Porto_Alegre_International.webp';
import src14 from '../assets/img/hub-clubs/LCU-Los_Cabos_United.webp';
import src15 from '../assets/img/hub-clubs/LEO-Mumbai_Leopards.webp';
import src16 from '../assets/img/hub-clubs/LUC-Luchadores.webp';
import src17 from '../assets/img/hub-clubs/MAR-Valparaiso_Mariners_AC.webp';
import src18 from '../assets/img/hub-clubs/MAY-Berlin_Mayhem.webp';
import src19 from '../assets/img/hub-clubs/MEL-Melbourne_United.webp';
import src20 from '../assets/img/hub-clubs/OIL-Alberta_SC.webp';
import src21 from '../assets/img/hub-clubs/OLP_Olympians_Cariocas.webp';
import src22 from '../assets/img/hub-clubs/OSV-Great_OSV.webp';
import src23 from '../assets/img/hub-clubs/RAI-Raizes_Sao_Paulo.webp';
import src24 from '../assets/img/hub-clubs/REV-Revolucao_Sao_Paulo.webp';
import src25 from '../assets/img/hub-clubs/ROY-Cambridge_Royals.webp';
import src26 from '../assets/img/hub-clubs/SAV-Rotorua_Savages.webp';
import src27 from '../assets/img/hub-clubs/SLB-San_Lorenzo_Bulls.webp';
import src28 from '../assets/img/hub-clubs/SON-Sons_of_the_Sahya.webp';
import src29 from '../assets/img/hub-clubs/SUN-Lagos_Sunshine.webp';
import src30 from '../assets/img/hub-clubs/SYC-Sycamore_FC.webp';
import src31 from '../assets/img/hub-clubs/TIJ-Tijuca_United.webp';

function normalize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function compact(value) {
  return normalize(value).replace(/ /g, '');
}
export const CLUBS = [
  { code: 'avl', name: 'Himachal Avalanche', src: src0 },
  { code: 'bbz', name: 'BBZ FC', src: src1 },
  { code: 'bdb', name: 'Blue Devils Busan', src: src2 },
  { code: 'ccc', name: 'Cusco Conductores', src: src3 },
  { code: 'cob', name: 'Cobras United', src: src4 },
  { code: 'cop', name: 'Copthorne SA', src: src5 },
  { code: 'flc', name: 'Doha Falcons', src: src6 },
  { code: 'gau', name: 'Cordoba Gauchos', src: src7 },
  { code: 'giz', name: 'Giza Club', src: src8 },
  { code: 'grr', name: 'Sarabi SC', src: src9 },
  { code: 'gym', name: 'The Gymnastic Society', src: src10 },
  { code: 'hos', name: 'Barts Hospital', src: src11 },
  { code: 'idf', name: 'Ile-de-France Foot', src: src12 },
  { code: 'int', name: 'Porto Alegre International', src: src13 },
  { code: 'lcu', name: 'Los Cabos United', src: src14 },
  { code: 'leo', name: 'Mumbai Leopards', src: src15 },
  { code: 'luc', name: 'Luchadores', src: src16 },
  { code: 'mar', name: 'Valparaiso Mariners AC', src: src17 },
  { code: 'may', name: 'Berlin Mayhem', src: src18 },
  { code: 'mel', name: 'Melbourne United', src: src19 },
  { code: 'oil', name: 'Alberta SC', src: src20 },
  { code: 'olp', name: 'Olympians Cariocas', src: src21 },
  { code: 'osv', name: 'Great OSV', src: src22 },
  { code: 'rai', name: 'Raizes Sao Paulo', src: src23 },
  { code: 'rev', name: 'Revolucao Sao Paulo', src: src24 },
  { code: 'roy', name: 'Cambridge Royals', src: src25 },
  { code: 'sav', name: 'Rotorua Savages', src: src26 },
  { code: 'slb', name: 'San Lorenzo Bulls', src: src27 },
  { code: 'son', name: 'Sons of the Sahya', src: src28 },
  { code: 'sun', name: 'Lagos Sunshine', src: src29 },
  { code: 'syc', name: 'Sycamore FC', src: src30 },
  { code: 'tij', name: 'Tijuca United', src: src31 },
];

const byCode = new Map();
const byName = new Map();
const byCompact = new Map();

CLUBS.forEach((club) => {
  const code = normalize(club.code);
  const name = normalize(club.name);
  byCode.set(code, club.src);
  byName.set(code, club.src);
  byName.set(name, club.src);
  byCompact.set(compact(club.name), club.src);
  byCompact.set(compact(club.code), club.src);
  byCompact.set(stripClubSuffix(club.name), club.src);
});

function stripClubSuffix(value) {
  return compact(value).replace(/(united|club|fc|sc|sa|ac)$/g, '');
}

export function clubLogoForTeam(name) {
  const key = normalize(name);
  if (!key) return null;
  return (
    byName.get(key) ||
    byCode.get(key) ||
    byCompact.get(compact(key)) ||
    byCompact.get(stripClubSuffix(key)) ||
    null
  );
}
